export default {"src":"/_next/static/media/wpp.b89e65b4.svg","height":89,"width":88};